// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._404-scope-JlyjR main{font-size:18px;margin-top:100px;text-align:center}._404-scope-JlyjR h1{font-size:36px}`, "",{"version":3,"sources":["webpack://./src/page/error/404.less"],"names":[],"mappings":"AAAA,uBAKQ,cAAA,CAFA,gBAAA,CACA,iBAAR,CAJA,qBASQ,cAFR","sourcesContent":[":local(.scope) {\n\n    main {\n        margin-top: 100px;\n        text-align: center;\n        font-size: 18px;\n    }\n\n    h1 {\n        font-size: 36px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scope": `_404-scope-JlyjR`
};
module.exports = ___CSS_LOADER_EXPORT___;
